/**
 * InvestorRedirect - Redirect investor-only users away from beneficiary routes
 *
 * Redirects users who ONLY have the investor role to the hub portal
 * when they try to access the regular beneficiary dashboard.
 *
 * Users with multiple roles (e.g., owner + investor) are NOT redirected,
 * allowing them to access the full beneficiary dashboard.
 */

import { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "@/contexts/AuthContext";
import { ROUTES } from "@/app/routes";

interface InvestorRedirectProps {
  children: React.ReactNode;
}

export const InvestorRedirect: React.FC<InvestorRedirectProps> = ({ children }) => {
  const authContext = useContext(AuthContext);
  const location = useLocation();

  if (!authContext) {
    throw new Error("InvestorRedirect must be used within AuthProvider");
  }

  if (
    authContext.isAuthenticated &&
    authContext.tokenManagement.isInvestorOnly() &&
    !location.pathname.startsWith(ROUTES.HUB.ROOT)
  ) {
    return <Navigate to={ROUTES.HUB.DASHBOARD} replace />;
  }

  return <>{children}</>;
};
